"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Flex, Text, Show as ChakraShow, forwardRef, useBreakpointValue, } from "@chakra-ui/react";
import { Link } from "../../atoms";
import { SIZE } from "./Footer.types";
const renderElements = (elements) => elements.map((_a, index) => {
    var { href, to, children, key } = _a, rest = __rest(_a, ["href", "to", "children", "key"]);
    return (_jsx(Flex, Object.assign({ pt: "3", alignItems: "center", sx: {
            ":not(:last-child):after": {
                h: "3",
                w: "1px",
                m: "2",
                my: "0.5",
                bgColor: "semantic.border.primary",
                display: "block",
                content: '""',
            },
        } }, { children: href || to ? (_jsx(Link, Object.assign({ href: href, to: to, variant: "primary", size: "small" }, rest, { children: children }))) : (_jsx(Text, Object.assign({ variant: "body.smallDemibold" }, { children: children }))) }), `${index}-${children}`));
});
const renderElement = (elements, size) => (_jsx(Flex, Object.assign({ sx: {
        justifyContent: size === SIZE.MOBILE ? "start" : "space-between",
        flexWrap: size === SIZE.MOBILE ? "wrap" : "nowrap",
    } }, { children: renderElements(elements) })));
const Footer = forwardRef((_a, ref) => {
    var { rightElements, leftElements } = _a, rest = __rest(_a, ["rightElements", "leftElements"]);
    const size = useBreakpointValue({
        sm: SIZE.MOBILE,
        md: SIZE.DESKTOP,
    }, {
        fallback: "sm",
    });
    return (_jsxs(Flex, Object.assign({ ref: ref, as: "footer", justifyContent: "space-between", px: { sm: "4", md: "8" }, paddingBottom: "3", backgroundColor: "semantic.surface.1", borderTop: "1px solid", borderColor: "semantic.border.secondary", width: "100%" }, rest, { children: [(leftElements === null || leftElements === void 0 ? void 0 : leftElements.length) ? renderElement(leftElements, size) : null, _jsx(ChakraShow, Object.assign({ above: "md" }, { children: (rightElements === null || rightElements === void 0 ? void 0 : rightElements.length) ? renderElement(rightElements, size) : null }))] })));
});
Footer.displayName = "Footer";
export default Footer;
//# sourceMappingURL=Footer.js.map